import { render, staticRenderFns } from "./EmprestimoSaidaSetor.vue?vue&type=template&id=04d84cd9&"
import script from "./EmprestimoSaidaSetor.vue?vue&type=script&lang=js&"
export * from "./EmprestimoSaidaSetor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports